import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "md:flex gap-2 md:gap-4 mt-4 md:mt-6" }
const _hoisted_2 = { class: "md:space-y-4 space-y-2 mx-auto" }
const _hoisted_3 = { class: "bg-gray-700 rounded-md animate-pulse h-72 w-56 m-auto md:m-0" }
const _hoisted_4 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_5 = { class: "rounded-md p-2 md:p-4 w-full bg-[#222222] text-white space-y-2 md:space-y-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-5 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-5 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "space-y-2 md:space-y-4 w-full" }
const _hoisted_10 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between gap-2 md:gap-4\"><div class=\"animate-pulse w-1/4 h-8 bg-gray-700 rounded-lg\"></div><div class=\"flex gap-2 md:gap-4\"><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg\"></div><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg hidden md:block\"></div><div class=\"animate-pulse w-8 h-8 bg-gray-700 rounded-lg hidden md:block\"></div></div></div>", 1)
const _hoisted_12 = { class: "flex flex-wrap gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-28 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end gap-2 md:gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-8 bg-gray-700 rounded-lg" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-20 h-8 bg-gray-700 rounded-lg" })
], -1)
const _hoisted_16 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-1/4 h-8 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_19 = { class: "hidden md:flex gap-2 md:gap-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-8 h-8 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-8 h-8 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-8 h-8 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "animate-pulse w-8 h-8 bg-gray-700 rounded-lg"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "flex gap-2 md:gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-full h-20 bg-gray-700 rounded-lg" })
], -1)
const _hoisted_25 = { class: "grid grid-cols-[repeat(auto-fill,_minmax(10rem,_1fr))] gap-2 md:gap-4" }
const _hoisted_26 = { class: "md:space-y-4 space-y-2 mx-auto" }
const _hoisted_27 = { class: "relative w-fit m-auto" }
const _hoisted_28 = { class: "h-72" }
const _hoisted_29 = {
  key: 0,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute right-1 top-1"
}
const _hoisted_30 = { class: "rounded-md p-2 md:p-4 w-full bg-[#222222] text-white space-y-2 md:space-y-4" }
const _hoisted_31 = { class: "flex justify-between items-center space-x-2 md:space-x-4 h-5" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Author", -1)
const _hoisted_33 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_34 = { class: "flex justify-between items-center space-x-2 md:space-x-4 h-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Status", -1)
const _hoisted_36 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_37 = { class: "flex justify-between items-center space-x-2 md:space-x-4 h-5" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Type", -1)
const _hoisted_39 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_40 = {
  key: 0,
  class: "flex justify-between items-center space-x-2 md:space-x-4 h-5"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Published", -1)
const _hoisted_42 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_43 = {
  key: 1,
  class: "flex justify-between items-center space-x-2 md:space-x-4 h-5"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Updated", -1)
const _hoisted_45 = { class: "text-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_46 = { class: "space-y-2 md:space-y-4 w-full" }
const _hoisted_47 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_48 = { class: "flex justify-between gap-2 md:gap-4" }
const _hoisted_49 = { class: "text-lg font-bold" }
const _hoisted_50 = { class: "flex gap-2 md:gap-4" }
const _hoisted_51 = { class: "flex flex-wrap gap-2" }
const _hoisted_52 = { class: "flex justify-end gap-2 md:gap-4" }
const _hoisted_53 = { class: "rounded-md p-2 md:p-4 w-full h-fit bg-[#222222] text-white text-start overflow-hidden space-y-2 md:space-y-4 md:mt-0 mt-2" }
const _hoisted_54 = { class: "flex items-center justify-between" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg" }, "Chapter", -1)
const _hoisted_56 = { class: "hidden md:flex items-center gap-2 md:gap-4" }
const _hoisted_57 = {
  key: 0,
  class: "flex gap-2 md:gap-4"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", null, "Read First Chapter", -1)
const _hoisted_59 = { class: "text-lg" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", null, "Read Last Chapter", -1)
const _hoisted_61 = { class: "text-lg" }
const _hoisted_62 = { class: "grid grid-cols-[repeat(auto-fill,_minmax(10rem,_1fr))] gap-2 md:gap-4" }
const _hoisted_63 = { class: "font-bold" }
const _hoisted_64 = { class: "text-gray-400" }

import { Button, Divider, Modal, Textarea } from 'ant-design-vue';
import { HttpStatusCode } from 'axios';
import { capitalize, createVNode, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
	AppstoreAddOutlined,
	DeleteFilled,
	DeleteOutlined,
	EditOutlined,
	ExportOutlined,
	ImportOutlined,
	PlusOutlined,
	StarFilled,
	StarOutlined
} from '@ant-design/icons-vue';
import AddChapter from '@/components/disposable/AddChapter.vue';
import ComicBulkAddChapter from '@/components/disposable/ComicBulkAddChapter.vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import LocationLink from '@/components/shared/LocationLink.vue';
import { Comic, ComicType } from '@/model/comic';
import {
	getComic,
	deleteComic,
	updateNoteComic,
	deleteComicChapter,
	favoriteComic
} from '@/repository/comic';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComicDetail',
  props: {
    type: {},
    dropable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { push } = useRouter();
const comicUUID = useRoute().params.comicUUID as string;
const store = useStore();

const isFetching = ref(true);
const isLoading = ref(true);
const comic = ref<Comic>();
const chapters = ref<string[]>([]);
const openedModal = ref<'add-chapter' | 'bulk-add-chapter' | 'closed'>('closed');
const isDelete = ref(false);
const isLoadingImage = ref(true);
const mode = ref<'INTERNAL' | 'EXTERNAL'>('INTERNAL');



onMounted(async () => fetchData());

function link(chapter: string) {
	if (mode.value === 'INTERNAL') {
		return `/${props.type}/${comicUUID}/${chapter}`;
	}
	return comic.value?.chapter[chapter].link || '';
}

async function fetchData() {
	isLoading.value = true;
	try {
		const res = await getComic(comicUUID);
		if (!res || res.status !== HttpStatusCode.Ok || !res.data) {
			throw Error('comic uuid is not found');
		}
		comic.value = res.data;
		chapters.value =
			Object.keys(comic.value.chapter || {}).sort((a, b) => Number(a) - Number(b)) || [];
		document.title = `${res.data.title} - ${capitalize(props.type)} | Unikume Kinkando`;
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
		push(`/${props.type}`);
	} finally {
		isLoading.value = false;
		isFetching.value = false;
	}
}

async function updateNote() {
	if (!comic.value) {
		return;
	}
	try {
		isLoading.value = true;
		await updateNoteComic(comicUUID, comic.value.note);
		store.dispatch('alert', { type: 'success', message: 'Update note successfully!' });
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

async function favorite() {
	if (!comic.value) {
		return;
	}
	comic.value.isFavorite = !comic.value.isFavorite;
	await favoriteComic(comicUUID, comic.value.isFavorite);
}

async function deleteComicData() {
	Modal.confirm({
		title: `Delete ${capitalize(props.type)}`,
		icon: createVNode(DeleteFilled),
		content: `Do you want to delete ${props.type} '${comic.value?.title}' right?`,
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			await deleteComic(comic.value?.comicUUID ?? '');
			await push(`/${props.type}`);
			store.dispatch('alert', {
				type: 'success',
				message: `delete ${props.type} ${comic.value?.title} successfully!`
			});
		}
	});
}

function dateTime(date: Date) {
	return new Date(date).toLocaleString('en-US', {
		year: 'numeric',
		month: 'short',
		day: '2-digit'
	});
}

async function deleteChapter(chapter: string) {
	if (!comic.value || !isDelete.value) {
		return;
	}
	Modal.confirm({
		title: `Delete Chapter ${chapter}`,
		icon: createVNode(DeleteOutlined),
		content: `Do you want to delete ${comic.value.title} chapter ${chapter}?`,
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			await deleteComicChapter(comic.value?.comicUUID ?? '', chapter);
			await fetchData();
			await store.dispatch('alert', {
				type: 'success',
				message: `Delete chapter ${chapter} successfully!`
			});
		}
	});
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (comic.value && comic.value.type !== _unref(ComicType).Novel)
      ? (_openBlock(), _createBlock(AddChapter, {
          key: 0,
          dropable: _ctx.dropable,
          comicUUID: comic.value?.comicUUID ?? '',
          isOpened: openedModal.value === 'add-chapter',
          onClose: () => (openedModal.value = 'closed'),
          onOnBeforeClose: fetchData
        }, null, 8, ["dropable", "comicUUID", "isOpened", "onClose"]))
      : _createCommentVNode("", true),
    (comic.value)
      ? (_openBlock(), _createBlock(ComicBulkAddChapter, {
          key: 1,
          comicUUID: comic.value?.comicUUID ?? '',
          isOpened: openedModal.value === 'bulk-add-chapter',
          onClose: () => (openedModal.value = 'closed'),
          comicType: comic.value.type,
          onOnBeforeClose: fetchData
        }, null, 8, ["comicUUID", "isOpened", "onClose", "comicType"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (isFetching.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_spin, {
                    tip: "Loading...",
                    size: "large",
                    class: "animate-pulse"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(5), (_, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flex justify-between items-center space-x-2 md:space-x-4"
                  }, _hoisted_8))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(3), (_, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "rounded-lg bg-gray-700 w-16 h-7"
                    }))
                  }), 128))
                ]),
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_13,
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_14,
                _hoisted_15
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    (_ctx.type !== _unref(ComicType).Novel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _hoisted_24,
                _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(10), (_, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "h-16 min-w-[9rem] w-full bg-gray-700 rounded-lg"
                    }))
                  }), 128))
                ])
              ])
            ])
          ], 64))
        : (comic.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(ImageLoading, {
                      previewable: "",
                      src: comic.value.imageURL,
                      "img-class": "!h-72 !w-56",
                      "loading-class": "h-72 w-56 m-auto md:m-0",
                      onLoad: _cache[0] || (_cache[0] = () => (isLoadingImage.value = false))
                    }, null, 8, ["src"])
                  ]),
                  (comic.value.isFavorite && !isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_unref(StarFilled))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(capitalize(comic.value.author)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, _toDisplayString(capitalize(comic.value.status)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, _toDisplayString(capitalize(comic.value.type)), 1)
                  ]),
                  (comic.value.createdAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createElementVNode("div", _hoisted_42, _toDisplayString(dateTime(comic.value.createdAt)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (comic.value.updatedAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, _toDisplayString(dateTime(comic.value.updatedAt)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(comic.value.title), 1),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_unref(Button), {
                        type: "primary",
                        onClick: favorite,
                        class: "bg-yellow-400 hover:!bg-yellow-500 text-orange-600 hover:!text-orange-600"
                      }, {
                        icon: _withCtx(() => [
                          (comic.value.isFavorite)
                            ? (_openBlock(), _createBlock(_unref(StarFilled), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(StarOutlined), { key: 1 }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(push)(`/${_ctx.type}/update/${comic.value.comicUUID}`))),
                        class: "hidden md:block"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(EditOutlined))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        danger: "",
                        type: "primary",
                        onClick: deleteComicData,
                        class: "hidden md:block"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comic.value.genres, (genre, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "rounded-md px-2 py-1 bg-[#343434] h-7"
                      }, _toDisplayString(genre), 1))
                    }), 128))
                  ]),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  _createElementVNode("div", null, _toDisplayString(comic.value.description), 1),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  _createVNode(_unref(Textarea), {
                    value: comic.value.note,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((comic.value.note) = $event)),
                    placeholder: `Enter a note`,
                    autoSize: "",
                    class: "bg-gray-600 text-white border-black placeholder:text-gray-400 !min-h-[116px]"
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_unref(Button), {
                      "html-type": "reset",
                      onClick: fetchData
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reset")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      "html-type": "submit",
                      type: "primary",
                      class: "disabled",
                      onClick: updateNote
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Update")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_unref(Button), {
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = () => (mode.value = mode.value === 'EXTERNAL' ? 'INTERNAL' : 'EXTERNAL'))
                      }, {
                        icon: _withCtx(() => [
                          (mode.value === 'INTERNAL')
                            ? (_openBlock(), _createBlock(_unref(ImportOutlined), { key: 0 }))
                            : _createCommentVNode("", true),
                          (mode.value === 'EXTERNAL')
                            ? (_openBlock(), _createBlock(_unref(ExportOutlined), { key: 1 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        type: "primary",
                        class: "bg-[#9e4fd3] hover:!bg-[#7c3fa5]",
                        onClick: _cache[4] || (_cache[4] = () => (openedModal.value = 'bulk-add-chapter'))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(AppstoreAddOutlined))
                        ]),
                        _: 1
                      }),
                      (!comic.value || comic.value.type !== _unref(ComicType).Novel)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 0,
                            type: "primary",
                            class: "bg-[#5cb85c] hover:!bg-[#518351]",
                            onClick: _cache[5] || (_cache[5] = () => (openedModal.value = 'add-chapter'))
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(PlusOutlined))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(Button), {
                        type: isDelete.value ? 'primary' : 'default',
                        danger: "",
                        onClick: _cache[6] || (_cache[6] = () => (isDelete.value = !isDelete.value))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(DeleteOutlined))
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ])
                  ]),
                  _createVNode(_unref(Divider), { class: "bg-gray-600" }),
                  (chapters.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createVNode(LocationLink, {
                          to: isDelete.value ? `` : link(chapters.value[0]),
                          isExternalLink: mode.value === 'EXTERNAL',
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), { class: "rounded-md h-20 w-full" }, {
                              default: _withCtx(() => [
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, "Chapter " + _toDisplayString(chapters.value[0]), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to", "isExternalLink"]),
                        _createVNode(LocationLink, {
                          to: isDelete.value ? `` : link(chapters.value[chapters.value.length - 1]),
                          isExternalLink: mode.value === 'EXTERNAL',
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Button), { class: "rounded-md h-20 w-full" }, {
                              default: _withCtx(() => [
                                _hoisted_60,
                                _createElementVNode("div", _hoisted_61, "Chapter " + _toDisplayString(chapters.value[chapters.value.length - 1]), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to", "isExternalLink"])
                      ]))
                    : _createCommentVNode("", true),
                  (chapters.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(Divider), {
                        key: 1,
                        class: "bg-gray-600"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapters.value, (chapter, index) => {
                      return (_openBlock(), _createBlock(LocationLink, {
                        key: index,
                        to: isDelete.value ? `` : link(chapter),
                        isExternalLink: mode.value === 'EXTERNAL' && !isDelete.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), {
                            class: "text-start h-16 min-w-[9rem] w-full",
                            onClick: () => deleteChapter(chapter)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_63, "Chapter " + _toDisplayString(chapter), 1),
                              _createElementVNode("div", _hoisted_64, _toDisplayString(dateTime(comic.value.chapter[chapter].createdAt!)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["to", "isExternalLink"]))
                    }), 128))
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})